import { render, staticRenderFns } from "./ShopifySettings.vue?vue&type=template&id=2cc4a167&scoped=true"
import script from "./ShopifySettings.vue?vue&type=script&lang=js"
export * from "./ShopifySettings.vue?vue&type=script&lang=js"
import style0 from "./ShopifySettings.vue?vue&type=style&index=0&id=2cc4a167&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc4a167",
  null
  
)

export default component.exports